import { Navigate } from 'react-router-dom'

export function SettingsHome() {
  return <Navigate to="/settings/insurance-plans" />
}
